var $9fec66bdd2f4ecde$exports = {};
$9fec66bdd2f4ecde$exports = {
    "more": `Mai multe articole`
};


export {$9fec66bdd2f4ecde$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
